// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavRightLightIconSignature {
  Element: SVGSVGElement;
}

export const NavRightLightIcon: TOC<NavRightLightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M6.39999 22.1L16.4 12.1L6.29999 1.99999L6.99999 1.29999L17.8 12.1L7.09999 22.8L6.39999 22.1Z"/>
</svg>
</template>;